module.exports = __webpack_public_path__ + "static/media/Logo_svg.9d2f49be.svg";